import { unzipAsync } from '../zip';
import { RelationshipPart } from './relationshipPart';
import type { RichText } from './richText';
import type { SharedStrings } from './sharedStrings';
import { WorkbookPart } from './workbookPart';
import type { Unzipped } from 'fflate';

export class XlsxFile {
  public readonly parser: DOMParser;
  public readonly decoder: TextDecoder;
  public rootRelationships: RelationshipPart | null;
  public workbook: WorkbookPart;
  public sharedStrings: SharedStrings;

  constructor(public readonly archive: Unzipped) {
    this.parser = new DOMParser();
    this.decoder = new TextDecoder();
    this.rootRelationships = RelationshipPart.fromFile('', this);
    this.rootRelationships?.init();
    this.workbook ??= (() => {
      throw new Error('Workbook does not exist');
    })();
    this.sharedStrings ??= (() => {
      throw new Error('Shared strings do not exist');
    })();
  }

  public static async fromBuffer(buffer: Uint8Array): Promise<XlsxFile> {
    const archive = await unzipAsync(buffer);
    return new XlsxFile(archive);
  }

  public getFile(path: string): Uint8Array | undefined {
    return this.archive[path];
  }

  public getOriginalXml(path: string): string | undefined {
    const file = this.getFile(path);
    if (file) {
      return this.decoder.decode(file);
    }
  }

  public getSharedString(idx: number): RichText | string | undefined {
    return this.sharedStrings?.strings[idx];
  }
}
